import React from "react";
import ListerLedger from "../lister/ListerLedger";

export default function CheckerLedger() {
    return <ListerLedger entityName="Checker" apiPrefix="checker" />;
}
